module.exports = __webpack_public_path__ + "media/images/font/Gustavo-BoldItalic-bf003753d02dea0f7c6251d440eb5010.woff";